import React from 'react';
import { styled } from 'styled-components';

interface CartBadgeProps {
  count: number;
  children: React.ReactNode;
}

export const CartBadge: React.FC<CartBadgeProps> = ({ count, children }) => {
  // 수량이 0이면 배지를 표시하지 않음
  if (count <= 0) {
    return <>{children}</>;
  }

  // 99 이상은 99+로 표시
  const displayCount = count > 99 ? '99+' : count.toString();

  return (
    <BadgeContainer>
      {children}
      <Badge>{displayCount}</Badge>
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const Badge = styled.span`
  position: absolute;
  top: 0px;
  right: 0px;
  min-width: 14px;
  height: 14px;
  background-color: ${({ theme }) => theme.colors.cartCountRed};
  color: ${({ theme }) => theme.colors.fontWhite};
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  border-radius: 7px;

  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 애니메이션 효과 */
  animation: badgeAppear 0.3s ease;
  
  @keyframes badgeAppear {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;